module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as2607-2e0fd068f2a8236a7e0f734398c4608b.jpg";